<template>
  <div class="dropdown-menu" ref="container" @click="toggleMenuState">
    <div class="dropdown-menu__label">
      <div
        v-if="!!$slots.icon"
        class="dropdown-menu__label__icon"
      >
        <slot name="icon"></slot>
      </div>
      <span class="dropdown-menu__label__text">{{label}}</span>
    </div>
    <ul :class="listClasses">
      <li
        v-for="item in itemsList"
        :key="item._uuid"
        :class="{'dropdown-menu__list__item': !item._hasSubitem}"
      >
        <ul
          class="dropdown-menu__sublist"
          v-if="item._hasSubitem"
        >
          <li
            class="dropdown-menu__sublist__item"
            v-for="subitem in item.subitems"
            :key="subitem._uuid"
          >
            <slot name="item-structure" v-bind:item="subitem"></slot>
          </li>
        </ul>
        <slot
          name="item-structure"
          v-else
          v-bind:item="item"
        ></slot>
      </li>
    </ul>
  </div>
</template>

<script>
import { isArray } from 'lodash'
export default {
  name: 'AppMenuDropdown',
  status: 'prototype',
  release: '1.0.0',
  props: {
    label: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      menuIsOpen: false
    }
  },
  computed: {
    listClasses () {
      return {
        'dropdown-menu__list': 'dropdown-menu__list',
        'dropdown-menu__list--open': !!this.menuIsOpen
      }
    },
    itemsList () {
      return this.items.map((item, index) => {
        const _uuid = index
        if (isArray(item)) {
          const subitems = item.map((subItem, indexSubitem) => {
            item._uuid = indexSubitem
            return subItem
          })

          return {
            _hasSubitem: true,
            _uuid,
            subitems
          }
        } else {
          return {
            ...item,
            _uuid
          }
        }
      })
    }
  },
  beforeMount () {
    window.addEventListener('click', (e) => {
      const dropdown = e.target.closest('.dropdown-menu')
      if (!dropdown || dropdown != this.$refs.container) {
        this.menuIsOpen = false
      }
    })
  },
  methods: {
    toggleMenuState () {
      this.menuIsOpen = !this.menuIsOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.dropdown-menu {
  position: relative;
  font-family: $font-text;
  &__label {
    @include reset();
    @include prevent-user-select();
    position: relative;
    min-width: 200px;
    height: 45px;
    padding: 12px 50px;
    z-index: 99;
    border-radius: 23px;
    box-shadow: $shadow-m;
    background-color: $color-white;
    cursor: pointer;
    text-align: center;
    &__icon {
      position: absolute;
      top: -3px;
      left: -3px;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      border: solid 3px $color-purple;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }
    &__text {
      font-weight: 600;
      font-size: $size-xs;
      text-align: center;
      color: $color-purple;
    }
  }
  &__list,
  &__sublist {
    @include reset();
    list-style: none;
    background-color: $color-white;
    &__item {
      display: block;
      padding-top: 15px;
      font-family: inherit;
      font-size: $size-xxs;
      color: $color-purple-darker;
      @media #{$media-query-m} {
        text-overflow: ellipsis;
      }
      a {
        font-family: inherit;
        font-size: inherit;
        color: inherit;
        text-decoration: none;
        @media #{$media-query-m} {
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        &.dropdown-menu__list__item--active,
        &:hover,
        &:focus {
          color: $color-purple;
        }
      }
    }
  }
  &__list {
    position: absolute;
    display: none;
    min-width: 100%;
    max-width: 100%;
    left: 0;
    top: 20px;
    padding: 30px 20px 15px 20px;
    z-index: 98;
    border-radius: 6px;
    box-shadow: $shadow-m;
    border: solid 2px $color-purple;
    overflow: hidden;
    @media #{$media-query-m} {
      max-width: none;
    }
    &--open {
      display: block;
    }
    &__item {
      padding: 15px 0;
      border-bottom: 1px solid rgb(234, 234, 234);
      &:last-child {
        border-bottom: 0;
      }
    }
  }
}
</style>
